module.exports = __webpack_public_path__ + "static/media/martindale-hubbel-distinguished.3e0e0d66.png";